import React, { useState } from "react";
import styled from "styled-components";

export default function CareerPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [resumeUrl, setResumeUrl] = useState("");
  const [coverLetter, setCoverLetter] = useState("");
  const handleSubmit = () => {
    const to = "hr@nfinitysolution.com";
    const subject = encodeURIComponent(`Resume Submission: ${role || "Candidate"}`);
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nPhone: ${phone}\nRole: ${role}\nResume URL: ${resumeUrl}\n\n${coverLetter}`
    );
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;
  };
  return (
    <Wrapper>
      <Inner className="container">
        <TopBar>
          <BackIconButton onClick={() => (window.history.length > 1 ? window.history.back() : (window.location.href = "/"))}>
            <ArrowIcon viewBox="0 0 24 24">
              <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </ArrowIcon>
            <span className="font13">Back</span>
          </BackIconButton>
        </TopBar>
        <Header>
          <h1 className="font40 extraBold">Careers</h1>
          <p className="font13">Submit your resume and details. Our HR team will get back to you.</p>
        </Header>
        <Form>
          <Group>
            <label>Full Name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="John Doe" />
          </Group>
          <Row>
            <Group style={{ flex: 1 }}>
              <label>Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="john@example.com" />
            </Group>
            <Group style={{ flex: 1 }}>
              <label>Phone</label>
              <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="+1 555 000 0000" />
            </Group>
          </Row>
          <Group>
            <label>Role Applying For</label>
            <input type="text" value={role} onChange={(e) => setRole(e.target.value)} placeholder="e.g., Frontend Engineer" />
          </Group>
          <Group>
            <label>Resume URL (Google Drive Public Link)</label>
            <input type="url" value={resumeUrl} onChange={(e) => setResumeUrl(e.target.value)} placeholder="Link to your resume" />
          </Group>
          <Group>
            <label>Cover Letter</label>
            <textarea value={coverLetter} onChange={(e) => setCoverLetter(e.target.value)} placeholder="Write a brief cover letter" />
          </Group>
          <Actions>
            <SubmitButton type="button" onClick={handleSubmit}>Send Application</SubmitButton>
          </Actions>
        </Form>
      </Inner>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const Inner = styled.div`
  padding: 100px 0 60px 0;
`;
const Header = styled.div`
  margin-bottom: 30px;
  @media (max-width: 760px) {
    text-align: center;
  }
`;
const Form = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);
  padding: 30px 20px;
`;
const Row = styled.div`
  display: flex;
  gap: 12px;
  @media (max-width: 760px) {
    flex-direction: column;
  }
`;
const Group = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  label {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
    color: #333;
  }
  input, textarea {
    padding: 12px 15px;
    border: 1px solid #ccc;
    border-radius: 10px;
    font-size: 16px;
    transition: all 0.3s ease;
  }
  textarea {
    min-height: 140px;
    resize: vertical;
  }
`;
const Actions = styled.div`
  display: flex;
  justify-content: flex-start;
`;
const SubmitButton = styled.button`
  border: none;
  background-color: #7620ff;
  color: #fff;
  padding: 14px 24px;
  font-size: 16px;
  border-radius: 10px;
  cursor: pointer;
`;
const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
`;
const BackIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: transparent;
  color: #090f52;
  cursor: pointer;
`;
const ArrowIcon = styled.svg`
  width: 20px;
  height: 20px;
`;